module.exports = __webpack_public_path__ + "static/img/ff.077823d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ff.png
// module id = txY9
// module chunks = 1